import { UtenteDTO, SessioneOlaStudenteDTO } from './newModel';

export class GenericCommand {
  public idUtenteOperazione: number;
  public nomeCompletoUtenteOperazione: string;

  constructor() {
    const utente: UtenteDTO = JSON.parse(sessionStorage.getItem('currentUser'));
    const operatore = !!utente ? utente.instructorOrTutor : null;
    if (!!utente && !!operatore) {
      this.nomeCompletoUtenteOperazione =
        operatore.cognome + ' ' + operatore.nome;
      this.idUtenteOperazione = operatore.id;
    }
  }
}

export class EliminaPrenotazioneStudenteCommand extends GenericCommand {
  public id: number;
  public nomeCompletoStudente: string;
}

export class SearchLogOperazioneCommand extends GenericCommand {
  public skip: number;
  public take: number;
  public idUtente: number;
  public idTipoOperazione: string;
}

export class AbilitaDisabilitaCommand extends GenericCommand {
  public active: boolean;
  public id: number;
}

export class AddUpdateRegistrazioneSistemaCommand extends GenericCommand {
  public id: number;
  public attiva: boolean;
}

export class SearchCorsiLaureaCommand extends GenericCommand {
  public skip: number;
  public take: number;
  public abilitatoDisabilitato: string;
}

export class SearchAuleCommand extends GenericCommand {
  public skip: number;
  public take: number;
  public abilitatoDisabilitato: string;
}

export class AppelloCommand extends GenericCommand {
  public idLaboratorio: number;
  public dataAppello: Date;
  public oraAppello: string;
  public idGruppoStudio: number;
  public listaPresenti: SessioneOlaStudenteDTO[];
  public idInstructor: number;
  public numeroOreAppello: number;
}

export class MenuUtenteCommand extends GenericCommand {
  public idGruppo: number;
}

export class SearchInstructorsOrTutorsCommand extends GenericCommand {
  public skip: number;
  public take;
  number;
  public withInfoGruppo: boolean;
  public type: boolean;
}

export class AddUpdateStudentePrenotazioneLaboratorioCommand extends GenericCommand {
  public id: number;
  public idStudente: number;
  public idLaboratorioLezioneTutoraggio: number;
  public dataLaboratorioLezioneTutoraggio: string;
}

export class SearchCategorySelfStudyCommand extends GenericCommand {
  public skip: number;
  public take: number;
}

export class SearchPrenotazioneLaboratorioCommand extends GenericCommand {
  public skip: number;
  public take: number;
  public idTutor: number;
  public dataCorrente: Date;
}

export class SearchSelfStudyDocumentCommand extends GenericCommand {
  public skip: number;
  public take: number;
  public idCategoria: string;
}

export class SearchPrenotatiProvaFinaleCommand extends GenericCommand {
  public skip: number;
  public take: number;
  public idProvaFinale: number;
  public idStudente: number;
}

export class SessioneOlaStudenteSearchCommand extends GenericCommand {
  public idStudente: number;
  public idSessioneOla: number;
  public idGruppoStudio: number;
  public skip: number;
  public take: number;
}

export class SelectCommand extends GenericCommand {
  public idSessioneOla: number;
  public active: Boolean;
  public tipo: string;
  public idoneo: Boolean;
}

export class SearchGruppiCommand extends GenericCommand {
  public skip: number;
  public take: number;
}

export class SearchGruppoStudioCommand extends GenericCommand {
  public idInstructor: string;
  public idCorsoLaurea: number;
  public idSessioneOla: number;
  public skip: number;
  public take: number;
  public nomeGruppo: string;
  public idGiorno: string;
  public orderByInstructor: boolean;
}

export class PercentualiStudioCommand extends GenericCommand {
  public idStudente: number;
  public idSessioneOla: number;
}

export class InstructorOrTutorGetCommand extends GenericCommand {
  public idInstructor: number;
}

export class GruppoStudioSearchCommand extends GenericCommand {
  public idInstructor: number;
  public idCorsoLaurea: number;
  public idSessioneOla: number;
  public skip: number;
  public take: number;
}

export class GruppoStudioLanguageLevelsSearchCommand extends GenericCommand {
  public idLanguageLevel: number;
  public idGruppoStudio: number;
  public skip: number;
  public take: number;
}

export class GruppoStudioGetCommand extends GenericCommand {
  public idGruppo: number;
}

export class GruppoStudioCorsiLaureaSearchCommand extends GenericCommand {
  public idCorsoLaurea: number;
  public idGruppoStudio: number;
  public skip: number;
  public take: number;
}

export class GetUtenteCommand extends GenericCommand {
  public username: string;
  public id: number;
  public withInfoGruppo: boolean;
}

export class SearchStudentiCommand extends GenericCommand {
  public idSessioneOla: number;
  public idCorsoLaurea: number;
  public matricola: number;
  public skip: number;
  public take: number;
  public offset: number;
  public cognome: String;
  public withInfoGruppoStudio: boolean;
  public approvataNonApprovata: String;
}

export class SearchSessioneOlaCommand extends GenericCommand {}

export class GetStudenteCommand extends GenericCommand {
  public withInfoGruppoStudio: Boolean;
  public withInfoCorsoLaurea: Boolean;
  public idSessioneOla: number;
  public matricola: string;
  public id: number;
}

export class AddUpdateUtenteCommand extends GenericCommand {
  public id: number;
  public username: string;
  public password: string;
  public idGruppo: number;
  public idStudente: number;
  public nomeStudente: string;
  public cognomeStudente: string;
  public matricola: string;
  public emailStudente: string;
  public idCorsoLaurea: number;
  public idSessioneOla: number;
  public nomeInstructorOrTutor: string;
  public cognomeInstructorOrTutor: string;
  public emailInstructorOrTutor: string;
  public telefono: string;
  public type: boolean; // 0 = instructor, 1 = tutor
  public idInstructorOrTutor: number;
  public withOtherUpdate: boolean;
  public force: boolean;
}

export class AddUtentePlacementCommand extends GenericCommand {
  public password: string;
  public nomeStudente: string;
  public cognomeStudente: string;
  public matricola: string;
  public emailStudente: string;
  public nomeCorsoLaurea: string;
  public nomeSessioneOla: string;
}

export class AddUpdateStudenteCommand extends GenericCommand {
  public id: number;
  public nome: string;
  public cognome: string;
  public matricola: string;
  public email: string;
  public idCorsoLaurea: number;
  public idGruppoStudio: number;
  public idSessioneOla: number;
  public oreInAula: number;
  public oreInLaboratorio: number;
  public oreStudioInAutonomia: number;
  public oreRecupero: number;
  public votoPlacementTest: number;
  public votoProvaFinale: number;
  public obbligoRecupero: boolean;
  public esonerato: boolean;
  public agendaStudioAutonomia: boolean;
  public agendaStudioAutonomiaVerificata: boolean;
  public note: string;
  public resetPassword: boolean;
  public oraleFacoltativo: boolean;
  public votoProvaFinaleOrale: String;
  public verificaOrePrenotazione: boolean;

  public esoneroOreInAula: boolean;
  public esoneroOreInLaboratorio: boolean;
  public esoneroAgendaStudio: boolean;

  public idSessioneOlaStudente: number;

  public dataEsame: Date;
}

export class AddUpdateSessioneOlaStudenteCommand extends GenericCommand {
  public id: number;
  public idSessioneOla: number;
  public idStudente: number;
  public idGruppoStudio: number;
  public idCorsoLaurea: number;
  public idTurnoEsame: number;
  public oreInAula: number;
  public oreInLaboratorio: number;
  public oreStudioInAutonomia: number;
  public oreRecupero: number;
  public votoPlacementTest: number;
  public esitoPositivoPlacementTest: boolean;
  public obbligoRecupero: boolean;
  public esonerato: boolean;
  public agendaStudioAutonomia: boolean;
  public note: string;
  public votoProvaFinale: number;
  public esitoProvaFinale: boolean;
  public richiestaCertificato: boolean;

  public idLaboratorio: number;
}

export class AddUpdateSessioneOlaCommand extends GenericCommand {
  public id: number;
  public nome: string;
  public mese: number;
  public anno: number;
  public idUtente: number;
  public active: Boolean;
  public durataSessione: number;
}

export class AddUpdateInstructorOrTutorCommand extends GenericCommand {
  public id: number;
  public nome: string;
  public cognome: string;
  public email: string;
  public telefono: string;
  public idGruppo: number;
  public password: string;
  public active: Boolean;
  public type: Boolean; // 0 = instructor , 1 = tutor
}

export class AddUpdateGruppoStudioLanguageLevelsCommand extends GenericCommand {
  public id: number;
  public idGruppoStudio: number;
  public idLanguageLevel: number;
}

export class AddUpdateGruppoCommand extends GenericCommand {
  public id: number;
  public nome: string;
  public descrizione: string;
  public codicePrivilegi: string[];
}

export class SendEmailCommand extends GenericCommand {
  public emailStudente: string;
  public emailInstructor: string;
  public oggetto: string;
  public messaggio: string;
  public nomeStudente: string;
}

export class AddUpdateAulaCommand extends GenericCommand {
  public id: number;
  public nome: string;
  public cubo: string;
  public numeroPostazioni: number;
  public contattiNoteAggiuntive: number;
  public idUtente: number;
  public tipo: string;
}

export class AddUpdateCorsoLaureaCommand extends GenericCommand {
  public id: number;
  public nome: number;
  public idUtente: number;
}

export class AddUpdateAulaGruppoStudioCommand extends GenericCommand {
  public id: number;
  public giornoSettimana: string;
  public oraInizio: string;
  public oraFine: string;
  public idAula: number;
  public idGruppoStudio: number;
}

export class AddUpdateGruppoStudioCommand extends GenericCommand {
  public idUtente: number;
  public auleGruppoStudio: AddUpdateAulaGruppoStudioCommand[];
  public idCorsiLaurea: string[];
  public idInstructor: number;
  public idLanguageLevels: string[];
  public idSessioneOla: number;
  public nome: string;
  public note: string;
  public numeroStudentiMassimo: number;
  public percentualeAttivazioneOreRecupero: number;
  public sogliaMinimaOreInAula: number;
  public sogliaMinimaOreInLaboratorio: number;
  public totaleOreInAula: number;
  public totaleOreStudioInAutonomia: number;
  public totaleOreInLaboratorio: number;
  public totaleOreRecupero: number;
  public votoMinimoSuperamentoPlacement: number;
  public votoMassimoSuperamentoPlacement: number;
  public votoMinimoSuperamentoProvaFinale: number;
  public votoMassimoSuperamentoProvaFinale: number;
  public dataInizio: Date;
  public active: Boolean;
  public id: number;
  public esoneroAgendaStudio: boolean;
  public esoneroOreInAula: boolean;
  public esoneroOreInLaboratorio: boolean;
}

export class AddUpdateGruppoStudioCorsoLaureaCommand extends GenericCommand {
  public id: number;
  public idGruppoStudio: number;
  public idCorsoLaurea: number;
}

export class AddUpdateLanguageLevelCommand extends GenericCommand {
  public id: number;
  public nome: string;
}

export class AddUpdatePrivilegioCommand extends GenericCommand {
  public id: number;
  public descrizione: string;
  public codice: string;
}

export class EliminaCommand extends GenericCommand {
  public id: number;
  public email: string;
}

export class EsitoTestCommand extends GenericCommand {
  public idStudente: number;
  public idSessioneOla: number;
}

export class GetCommand extends GenericCommand {
  public id: number;
}

export class GetGruppoCommand extends GenericCommand {
  public nome: string;
}

export class GetGruppoStudioCommand extends GenericCommand {
  public withInfoStudente: Boolean;
  public withInfoCorsoLaurea: Boolean;
  public withInfoLanguageLevels: Boolean;
  public id: number;
}

export class GetInstructorOrTutorCommand extends GenericCommand {
  public email: string;
}

export class LoginCommand extends GenericCommand {
  public username: string;
  public password: string;
}

export class AddUpdateSelfStudyDocumentCommand extends GenericCommand {
  public id: number;
  public idUtente: number;
  public idCategorySelfStudy: number;
  public nome: string;
  public descrizione: string;
  public link: string;
}

export class AddUpdateCategorySelfStudyCommand extends GenericCommand {
  public id: number;
  public idUtente: number;
  public nome: string;
  public ordinamento: number;
}

export class AddUpdateLaboratorioLezioneTutoraggioCommand extends GenericCommand {
  public idAula: number;
  public idTutor: number;
  public idUtente: number;
  public dataInizio: Date;
  public dataFine: Date;
  public postiTotali: number;
  public postiDisponibili: number;
  public active: boolean;
  public id: number;
  public idSessioneOla: number;
  public inPresenza: boolean;
}

export class SearchProvaFinaleCommand extends GenericCommand {
  public skip: number;
  public take: number;
  public abilitatoDisabilitato: string;
  public fromToday: boolean;
}

export class AddUpdateProvaFinaleCommand extends GenericCommand {
  public id: number;
  public dataMassimaPrenotazione: Date;
  public dataMinimaPrenotazione: Date;
  public dataProva: Date;
  public idCorsiLaurea: string[];
  public idUtente: number;
  public idAula: number;
  public nome: string;
  public orale: boolean;
}

export class SearchStudentePrenotazioneLaboratorioCommand extends GenericCommand {
  public skip: number;
  public take: number;
  public idStudente: number;
  public idSessioneOla: number;
  public idLaboratorioLezioneTutoraggio;
}

export class GetProveEsamiDisponibiliCommand extends GenericCommand {
  public idCorsoDiLaurea: number;
  public dataCorrente: Date;
  public idStudente: number;
  public orale: boolean;
}

export class AddUpdatePrenotatiProvaFinaleCommand extends GenericCommand {
  public id: number;
  public idStudente: number;
  public idProvaFinale: number;
  public matricola: number;
}

export class SearchLaboratorioLezioneTutoraggioCommand extends GenericCommand {
  public skip: number;
  public take: number;
  public offset: number;
  public idSessioneOla: number;
  public idTutor: number;
  public mostraTutti: boolean;
  public active: boolean;
  public dataSelected: Date;
}
